import { customIconMap } from './customIconMap';
import { lucideIconsMap } from './lucideIconMap';

export type LucideIconName = keyof typeof lucideIconsMap;

export type CustomIconName = keyof typeof customIconMap;

/**
 * Union type for all available icons in the system
 */
export type NoddiIconName = LucideIconName | CustomIconName;

/**
 * Utility function to determine if an icon name belongs to Lucide or Noddi icon set
 */
export const isLucideIcon = (iconName: NoddiIconName): iconName is LucideIconName => {
  return iconName in lucideIconsMap;
};

export const sizeMap = {
  xSmall: 12,
  small: 16,
  xMedium: 20,
  medium: 24,
  large: 32,
  xLarge: 48
} as const;

export type IconSize = keyof typeof sizeMap;

// The `size` prop accepts a scale token (preferred) or a raw pixel number for the
// rare off-scale icon. Sizing must go through this prop, never a `size-*`/`w-*`/`h-*`
// className: lucide spreads className onto every child shape, so width/height
// utilities distort icons built with <rect>/<circle> (enforced by the
// `noddi/enforce-icon-size-prop` lint rule).
export type IconSizeValue = IconSize | number;

export const resolveIconSize = (size: IconSizeValue): number => (typeof size === 'number' ? size : sizeMap[size]);
